/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FormPreviewBackground from './FormPreviewBackground.vue';

// Utils
import { get } from 'lodash';

const __vue_script__ = {
    name: 'FormPreview',

    components: { FormPreviewBackground },

    props: {
        buttonBackgroundColor: {
            type: String,
            default: '#3687FA',
        },

        buttonForegroundColor: {
            type: String,
            default: '#FFFFFF',
        },

        hideCalendar: {
            type: Boolean,
            default: false,
        },

        hideDateInfo: {
            type: Boolean,
            default: false,
        },

        banner: {
            type: Array,
            default: () => [],
        },

        event: {
            type: Object,
            required: true
        }
    },

    computed: {
        bannerUrl() {
            return get(this.banner, '0.url') || get(this.banner, '0');
        },

        appIconPath() {
            return this.$utils.assets.getEventAssetPath(this.event._id, 'theme/app-icon');
        }
    },
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "100 96 651 450",
      },
    },
    [
      _c("form-preview-background"),
      !_vm.bannerUrl
        ? _c("rect", {
            attrs: {
              stroke: "#BEBFC1",
              fill: "#F3F3F3",
              rx: "4.5",
              height: "87",
              width: "365",
              y: "112.5",
              x: "241.5",
            },
          })
        : _vm._e(),
      _vm.bannerUrl
        ? _c(
            "foreignObject",
            { attrs: { height: "87", width: "365", y: "112.5", x: "241.5" } },
            [
              _c("img", {
                staticStyle: { "border-radius": "8px" },
                attrs: { src: _vm.bannerUrl, width: "365", height: "87" },
              }),
            ]
          )
        : _vm._e(),
      !_vm.appIconPath
        ? _c("rect", {
            attrs: {
              fill: "#F3F3F3",
              rx: "5",
              height: "36.129",
              width: "36.129",
              y: "221.032",
              x: "250.032",
            },
          })
        : _c("image", {
            attrs: {
              href: _vm.appIconPath,
              x: "250.032",
              y: "221.032",
              width: "36.129",
              height: "36.129",
              rx: "4.5",
              "clip-path": "url(#clip_logo)",
            },
          }),
      !_vm.hideDateInfo
        ? _c("rect", {
            attrs: {
              fill: "#F3F3F3",
              rx: "3",
              height: "11",
              width: "135",
              y: "240",
              x: "295",
            },
          })
        : _vm._e(),
      !_vm.hideCalendar
        ? _c("g", [
            _c("path", {
              attrs: {
                fill: "#F3F3F3",
                d: "M574 228C574 225.239 576.239 223 579 223H593C595.761 223 598 225.239 598 228V241C598 243.761 595.761 246 593 246H579C576.239 246 574 243.761 574 241V228Z",
              },
            }),
            _c("path", {
              attrs: {
                fill: "#2D3339",
                d: "M581.125 241C580.504 241 580 240.495 580 239.875V231.625C580 231.004 580.504 230.5 581.125 230.5H583V229.375C583 229.168 583.168 229 583.375 229C583.582 229 583.75 229.168 583.75 229.375V230.5H588.25V229.375C588.25 229.168 588.418 229 588.625 229C588.832 229 589 229.168 589 229.375V230.5H590.875C591.495 230.5 592 231.004 592 231.625V239.875C592 240.495 591.495 241 590.875 241H581.125ZM580.75 239.875C580.75 240.082 580.918 240.25 581.125 240.25H590.875C591.082 240.25 591.25 240.082 591.25 239.875V234.25H580.75V239.875ZM591.25 231.625V233.5H580.75V231.625C580.75 231.418 580.918 231.25 581.125 231.25H583V232C583 232.207 583.168 232.375 583.375 232.375C583.582 232.375 583.75 232.207 583.75 232V231.25H588.25V232C588.25 232.207 588.418 232.375 588.625 232.375C588.832 232.375 589 232.207 589 232V231.25H590.875C591.082 231.25 591.25 231.418 591.25 231.625ZM582.812 236.5C583.123 236.5 583.375 236.248 583.375 235.938C583.375 235.627 583.123 235.375 582.812 235.375C582.502 235.375 582.25 235.627 582.25 235.938C582.25 236.248 582.502 236.5 582.812 236.5ZM583.375 238.562C583.375 238.873 583.123 239.125 582.812 239.125C582.502 239.125 582.25 238.873 582.25 238.562C582.25 238.252 582.502 238 582.812 238C583.123 238 583.375 238.252 583.375 238.562ZM586 236.5C586.311 236.5 586.562 236.248 586.562 235.938C586.562 235.627 586.311 235.375 586 235.375C585.689 235.375 585.438 235.627 585.438 235.938C585.438 236.248 585.689 236.5 586 236.5ZM586.562 238.562C586.562 238.873 586.311 239.125 586 239.125C585.689 239.125 585.438 238.873 585.438 238.562C585.438 238.252 585.689 238 586 238C586.311 238 586.562 238.252 586.562 238.562ZM589.188 236.5C589.498 236.5 589.75 236.248 589.75 235.938C589.75 235.627 589.498 235.375 589.188 235.375C588.877 235.375 588.625 235.627 588.625 235.938C588.625 236.248 588.877 236.5 589.188 236.5ZM588.625 238.562C588.625 238.873 588.877 239.125 589.188 239.125C589.498 239.125 589.75 238.873 589.75 238.563C589.75 238.264 589.516 238.017 589.224 238.003L589.21 238.002C589.203 238 589.194 238 589.188 238C588.877 238 588.625 238.252 588.625 238.562Z",
                "clip-rule": "evenodd",
                "fill-rule": "evenodd",
              },
            }),
          ])
        : _vm._e(),
      _c("g", [
        _c("rect", {
          attrs: {
            fill: _vm.buttonBackgroundColor,
            rx: "5",
            height: "24",
            width: "366",
            y: "466.064",
            x: "241",
          },
        }),
        _c("path", {
          attrs: {
            fill: _vm.buttonForegroundColor,
            d: "M409.267 482.171C410.907 482.171 411.957 481.331 411.957 479.983V479.979C411.957 478.934 411.352 478.338 409.872 478.021L409.105 477.85C408.192 477.654 407.821 477.312 407.821 476.79V476.785C407.821 476.121 408.432 475.735 409.257 475.735C410.111 475.73 410.663 476.15 410.756 476.727L410.766 476.79H411.825L411.82 476.722C411.742 475.628 410.766 474.783 409.271 474.783C407.777 474.783 406.723 475.623 406.718 476.839V476.844C406.718 477.884 407.333 478.548 408.764 478.851L409.535 479.017C410.468 479.217 410.849 479.568 410.849 480.11V480.115C410.849 480.77 410.209 481.219 409.311 481.219C408.368 481.219 407.689 480.809 407.631 480.169L407.626 480.115H406.552L406.557 480.179C406.654 481.365 407.675 482.171 409.267 482.171ZM415.043 482.103C415.814 482.103 416.352 481.771 416.605 481.199H416.688V482H417.743V476.697H416.688V479.808C416.688 480.662 416.234 481.194 415.385 481.194C414.608 481.194 414.286 480.76 414.286 479.881V476.697H413.227V480.13C413.227 481.385 413.847 482.103 415.043 482.103ZM422.089 482.088C423.427 482.088 424.286 481.019 424.286 479.354V479.344C424.286 477.664 423.437 476.604 422.089 476.604C421.361 476.604 420.741 476.966 420.458 477.537H420.38V474.617H419.32V482H420.38V481.165H420.458C420.766 481.746 421.347 482.088 422.089 482.088ZM421.791 481.185C420.907 481.185 420.36 480.486 420.36 479.354V479.344C420.36 478.211 420.907 477.513 421.791 477.513C422.675 477.513 423.207 478.206 423.207 479.344V479.354C423.207 480.491 422.675 481.185 421.791 481.185ZM425.551 482H426.61V478.743C426.61 478.05 427.084 477.503 427.724 477.503C428.349 477.503 428.744 477.884 428.744 478.489V482H429.799V478.646C429.799 478.006 430.243 477.503 430.917 477.503C431.61 477.503 431.942 477.864 431.942 478.597V482H432.997V478.343C432.997 477.239 432.372 476.595 431.303 476.595C430.565 476.595 429.955 476.971 429.687 477.542H429.604C429.369 476.971 428.856 476.595 428.134 476.595C427.44 476.595 426.923 476.932 426.688 477.513H426.61V476.697H425.551V482ZM435.028 475.75C435.39 475.75 435.692 475.452 435.692 475.091C435.692 474.725 435.39 474.427 435.028 474.427C434.662 474.427 434.364 474.725 434.364 475.091C434.364 475.452 434.662 475.75 435.028 475.75ZM434.496 482H435.551V476.697H434.496V482ZM439.096 482.034C439.301 482.034 439.496 482.01 439.667 481.98V481.136C439.521 481.15 439.428 481.155 439.267 481.155C438.744 481.155 438.529 480.921 438.529 480.35V477.532H439.667V476.697H438.529V475.359H437.45V476.697H436.62V477.532H437.45V480.604C437.45 481.624 437.929 482.034 439.096 482.034Z",
          },
        }),
      ]),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/registrations/preview/FormPreview.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__